import React, { useState } from "react";
import { ConfirmPopup } from "../Confirmation";
import { newsColumnsConfig } from "../config/News";

export const getNewsColumns = ({ onDeleteClick, onEditClick, onViewClick }) => {
  const [confirmOpenForId, setConfirmOpenForId] = useState(null);

  // ✅ Format date safely
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (error) {
      return dateString;
    }
  };

  return [
    {
      name: <span className="font-weight-bold fs-13">{newsColumnsConfig.TITLE}</span>,
      selector: (row) => row.title || "",
      cell: (row) => (
        <div
          onClick={() => onViewClick?.(row)}
          style={{
            fontWeight: "500",
            marginBottom: "4px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            minWidth: "250px",
            cursor: "pointer",
            width: "100%",
          }}
          title={row.title}
        >
          {row.title || "-"}
        </div>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">{newsColumnsConfig.DESCRIPTION}</span>,
      selector: (row) => row.description || "",
      cell: (row) => (
        <div
          onClick={() => onViewClick?.(row)}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
            cursor: "pointer",
          }}
          title={row.description}
        >
          {row.description || "-"}
        </div>
      ),
      width: "500px",
    },
    {
      name: <span className="font-weight-bold fs-13">{newsColumnsConfig.CREATED}</span>,
      selector: (row) => row.createdAt || "",
      sortable: true,
      cell: (row) => (
        <div
          onClick={() => onViewClick?.(row)}
          style={{ cursor: "pointer", width: "100%" }}
          title={formatDate(row.createdAt)}
        >
          {formatDate(row.createdAt)}
        </div>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">{newsColumnsConfig.ACTIONS}</span>,
      sortable: false,
      cell: (row) => (
        <div className="d-flex align-items-center justify-content-center gap-2">
          {/* Edit Icon */}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              onEditClick?.(row);
            }}
            className="text-decoration-none px-1 py-2"
            title="Edit"
          >
            <i className="ri-edit-2-fill fs-13 text-primary p-2 rounded-circle shadow-sm bg-f1" />
          </a>

          {/* Delete Icon */}
          <>
            <a
              href="#"
              onClick={(event) => {
                event.preventDefault();
                setConfirmOpenForId(row._id);
              }}
              className="text-decoration-none px-1 py-2"
              title="Delete"
            >
              <i className="ri-delete-bin-7-fill fs-13 text-danger p-2 rounded-circle shadow-sm bg-f1" />
            </a>

            {confirmOpenForId === row._id && (
              <ConfirmPopup
                message={newsColumnsConfig.message} // ✅ use message from config
                setConfirmOpen={() => setConfirmOpenForId(null)}
                onConfirm={(event) => {
                  onDeleteClick?.(event, row._id);
                  setConfirmOpenForId(null);
                }}
              />
            )}
          </>
        </div>
      ),
    },
  ];
};
